import { BsXCircleFill } from 'react-icons/bs'
import styled, { css } from 'styled-components/macro'

export const FilterChipContainer = styled.span<{
  isExclusive?: boolean
  isHovered?: boolean
}>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  color: #087443;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-radius: 4px;
  background: #e5ece7;
  height: 40px;
  border: 1px solid transparent;
  box-sizing: border-box;

  b {
    font-weight: 600;
  }

  ${({ isExclusive }) =>
    isExclusive &&
    css`
      background: #ffe8ea;
      color: #9c1f2f;
    `}

  ${({ isHovered, isExclusive }) =>
    isHovered &&
    !isExclusive &&
    css`
      background: #f4f7f5;
      border: 1px solid #c1d1c6;
      color: #06512f;
    `}

  ${({ isHovered, isExclusive }) =>
    isHovered &&
    isExclusive &&
    css`
      background: #ffeeef;
      border: 1px solid #fbdddf;
      color: #9c1f2f;
    `}

  @media (max-width: 768px) {
    height: 24px;
    font-size: 12px;
    line-height: 24px;
  }
`

export const FilterChipCloseButton = styled(BsXCircleFill)<{
  isExclusive?: boolean
}>`
  color: ${(props) => (props.isExclusive ? '#9C1F2F' : '#087443')};
  width: 16px;
  height: 16px;
  cursor: pointer;
  flex-shrink: 0;
`
